import { useMediaQuery } from "@mui/material";
import { DesktopNav } from "./DesktopNav";
import { HamburgerNav } from "./HamburgerNav";

const Navigation: React.FC = () => {
	const breakpoint = 980;
	const isSmallScreen = useMediaQuery(`(max-width: ${breakpoint}px)`, {
		noSsr: true,
	});

	return isSmallScreen ? <HamburgerNav /> : <DesktopNav />;
};

export { Navigation };
